import { persistedState } from '@/utils/store-helpers';
import { axiosInstance } from '@/plugins/axios';
import moment from 'moment-timezone';

const refreshInterval = persistedState('callsRefreshInterval');

export const moduleState = {
  calls: [],
  pagination: {
    currentPage: 1,
    pageSize: 10,
    totalRecords: 0,
  },
  sortBy: '-DELIVERY_DATETIME_UTC',
  loading: false,
  visibleDateRange: [
    /* From */
    new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    /* To */
    dateRangeEnd(),
  ],
  callsRefreshInterval: refreshInterval.initial(0),
};

function dateRangeEnd() {
  const d = new Date();
  d.setHours(23, 59, 59, 999);
  return d;
}

export const getters = {
  hasOngoingCall(state) {
    return state.calls.some(call => call.status === 'Ongoing');
  },
};

export const actions = {
  async getCalls({ commit, state, rootGetters }, { clientId, search, from, to }) {
    commit('setLoading', true);

    const nowUtcFromClientTimezone = moment()
      .tz(rootGetters['client/clientTimezone'], true)
      .utc()
      .toDate();
    const params = {
      ClientId: clientId,
      pageNum: state.pagination.currentPage,
      PageSize: state.pagination.pageSize,
      from,
      to,
      prependOngoingCalls: !search && to >= nowUtcFromClientTimezone,
    };

    if (search != null && search !== '') {
      params.search = search;
    }

    if (state.sortBy != null && state.sortBy !== '') {
      params.sortBy = state.sortBy;
    }

    const response = await axiosInstance
      .get(`api/leads/calls/search`, {
        params,
      })
      .catch(err => {
        console.error(err);
        return Promise.reject(err);
      });
    commit('setCalls', response.data.items || []);
    commit('setPagination', response.data.metaData);
    commit('setLoading', false);

    return response.data;
  },

  setCurrentPage({ commit, dispatch }, { pageNumber, getCallsData }) {
    commit('setCurrentPage', pageNumber);
    dispatch('getCalls', getCallsData);
  },

  setSortBy({ commit, dispatch }, { sortBy, getCallsData }) {
    commit('setSortBy', sortBy);
    dispatch('getCalls', getCallsData);
  },

  setVisibleDateRange({ commit }, dateRange) {
    commit('setVisibleDateRange', dateRange);
  },

  reset({ commit }) {
    commit('setCalls', []);
  },
};

export const mutations = {
  setLoading(state, value) {
    state.loading = value;
  },
  setCalls(state, value) {
    state.calls = value;
  },
  setPagination(state, value) {
    state.pagination = value;
  },
  setSortBy(state, value) {
    state.sortBy = value;
  },
  setVisibleDateRange(state, value) {
    state.visibleDateRange = value;
  },
  setAutoRefreshInterval: refreshInterval.set,

  setCurrentPage(state, newValue) {
    state.pagination.currentPage = newValue;
  },

  setPageSize(state, newValue) {
    state.pagination.pageSize = newValue;
  },
};
